// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".live-equipment .ant-card-body {\n    padding: 10px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/GroupAnalyticsPage/components/AnalyticsCards/LiveStatusCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB","sourcesContent":[".live-equipment .ant-card-body {\n    padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
